module.exports = __webpack_public_path__ + "sb.svg?ab93a7990b049074d06db8b0bc7b3ce2";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/4x3/sb.svg
// module id = 1341
// module chunks = 0